import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)


/*
 * Swiper
*/

import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

// Single
const postSwiper = new Swiper('.post-swiper', {
  slidesPerView: 1,
  spaceBetween: 18,
  centeredSlides: false,
  /*
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  */
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 48,
      initialSlide: 1,
      centeredSlides: true,
    }
  }
});

// Hero
const heroSwiper = new Swiper('.hero-swiper', {
  modules: [Pagination, EffectFade],
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});


/*
 * Single product
*/
let SingleProductSwiper; // 再初期化用に保持
const breakpoint = window.matchMedia('(max-width: 575px)');

function enableSingleProductSwiper() {
  if (!SingleProductSwiper) {
    SingleProductSwiper = new Swiper(".product-gallery-swiper", {
      modules: [Pagination, Navigation],
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      spaceBetween: 10,
      slidesPerView: 1,
    });
  }
}

function destroySingleProductSwiper() {
  if (SingleProductSwiper) {
    SingleProductSwiper.destroy(true, true); // インスタンスとstyleを削除
    SingleProductSwiper = null;
  }
}

function checkBreakpoint() {
  if (breakpoint.matches) {
    enableSingleProductSwiper();  // 575px以下 → Swiper有効
  } else {
    destroySingleProductSwiper(); // 578px以上 → Swiper無効
  }
}

breakpoint.addEventListener('change', checkBreakpoint);
document.addEventListener('DOMContentLoaded', checkBreakpoint);


/*
 * IntersectionObserver - Scroll Color Changer
 */

document.addEventListener('DOMContentLoaded', function () {
  const targets = document.querySelectorAll('[data-bg][data-color]');
  const root = document.documentElement;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;
      const bg = el.dataset.bg;
      const color = el.dataset.color;

      if (entry.isIntersecting) {
        // 表示エリアに入ったら適用
        root.style.setProperty('--body-bg', bg);
        root.style.setProperty('--body-color', color);
      } else {
        // 表示エリアから出たらリセット（空またはデフォルト値）
        root.style.removeProperty('--body-bg');
        root.style.removeProperty('--body-color');
      }
    });
  }, {
    threshold: 0, // 1pxでも入ったら発火（下で調整）
    rootMargin: '0px 0px -75% 0px',
  });

  targets.forEach(el => observer.observe(el));
});
